"use client"

import clsx from "clsx"

import type { PropsWithClassName } from "~/@types/generics"
import { Image } from "~/components/ui/Image"
import RichText from "~/components/ui/RichText"
import type { TProduct } from "~/components/globals/Product/_data/serializer"

import { text } from "~/styles/variants"

import * as css from "./styles.css"

export type AlmaProps = PropsWithClassName<{
  data: NonNullable<TProduct>["almaContent"]
}>

export function Alma({ className, data }: AlmaProps) {
  if (!data) return null

  return (
    <div className={clsx(className, css.Alma)}>
      <RichText
        render={data.text}
        className={text({
          design: "riposte-13",
          weight: "light",
          color: "blue-light-txt",
          lineHeight: 1.3,
        })}
      />
      <Image {...data.image} ratio="33/17" className={css.almaImage} />
    </div>
  )
}
